import { CreateNationalEventForm } from '@/services/Calendar/NationalEvents/forms/CreateNationalEventForm';

export class EditNationalEventForm extends CreateNationalEventForm {
}
